import { createStore, compose, applyMiddleware, StoreEnhancerStoreCreator } from "redux";
import { routerMiddleware } from "react-router-redux";

import generateReducer, { RootState } from "../generateReducer";

export default function configureStore(history: any, initialState = {} as RootState) {
  // NOTE(miyashiro): For devtools
  const composeEnhancers: typeof compose =
    process.env.NODE_ENV === "development" && typeof window === "object"
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose;

  const store = createStore<RootState>(
    generateReducer(),
    initialState,
    composeEnhancers<StoreEnhancerStoreCreator<RootState>>(applyMiddleware(routerMiddleware(history)))
  );

  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept(["../generateReducer"], () => {
      store.replaceReducer(generateReducer() as any);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./frontend/src/store/configureStore.ts